import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import type { ColorToken, SpacingToken } from '../types';
import { Well } from '../Well';

export type BainGenericContainerProps = StructuredContentDocument<{
  marginTop?: SpacingToken;
  marginBottom?: SpacingToken;
  marginLeft?: SpacingToken;
  marginRight?: SpacingToken;
  paddingTop?: SpacingToken;
  paddingBottom?: SpacingToken;
  paddingLeft?: SpacingToken;
  paddingRight?: SpacingToken;
  backgroundColor?: ColorToken;
  children: StructuredContentDocument;
}>;

export function BainGenericContainer(props: BainGenericContainerProps) {
  return <Well {...props} />;
}
